<template>

  <v-navigation-drawer
      id="core-navigation-drawer"
      v-model="drawer"
      :dark="barColor !== 'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)'"
      :expand-on-hover="expandOnHover"
      :right="$vuetify.rtl"
      src="@/assets/background.jpg"
      mobile-breakpoint="960"
      app
      width="260"
      v-bind="$attrs"
  >
    <template v-slot:img="props">
      <v-img
          :gradient="`to bottom, ${barColor}`"
          v-bind="props"
      />
    </template>

    <v-divider class="mb-1"/>

    <v-list
        expand
        nav
        white
    >
      <v-list-item>
        <v-list-item-avatar
            class="align-self-center"
            contain
            min-width="70"
            min-height="70"
        >
          <router-link
              :to="{ name: 'dashboard' }"
              class="unstyled-link">
            <v-img
                src="@/assets/logo.png"
                min-width="70"
                min-height="70"
                class="reset-image"
            />
          </router-link>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title
              class="display-2"
              v-text="profile.title"
          />
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-divider class="mb-2"/>

    <v-list
        nav
        dense
        v-if="isAuthenticated"
    >

      <template v-for="(group, i) in authenticatedMenu">
        <v-list-group
            group="group.group"
            no-action
            :key="i"
            sub-group
            value="true"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>{{ group.title }}</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
              v-for="(item, i) in group.links"
              :key="i"
              link
              :to="item.path"
          >
            <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>

            <v-list-item-title v-text="item.title"></v-list-item-title>
          </v-list-item>
        </v-list-group>

      </template>

    </v-list>

    <v-list
        nav
        dense
        v-if="!isAuthenticated"
        active-class="v-list-item--active"
    >
      <template>

        <v-list-item
            v-for="(item, i) in notAuthenticatedMenu"
            :key="i"
            link
            :to="item.path"
        >
          <v-list-item-icon>
            <v-icon v-text="item.icon"></v-icon>
          </v-list-item-icon>

          <v-list-item-title v-text="item.title"></v-list-item-title>
        </v-list-item>

      </template>

    </v-list>


    <template v-slot:append>
    </template>
  </v-navigation-drawer>
</template>

<script>
// Utilities
import {mapState, mapMutations} from 'vuex'
import securityUtils from '@/utils/security'

export default {
  name: 'CoreDrawer',

  props: {
    expandOnHover: {
      type: Boolean,
      default: false,
    },
  },

  created() {
    this.errorCode = this.$route.query.errorCode
    this.setDrawer(null)
  },

  computed: {
    ...mapState(['drawer', 'barColor', 'barImage']),
    isAuthenticated() {
      return securityUtils.isAuthenticated()
    },
    profile() {
      return {
        avatar: true,
        title: this.$t('avatar'),
      }
    }
  },

  methods: {
    ...mapMutations({
      setDrawer: 'setDrawer',
    }),
    navigate(route) {
      this.$router.push(route)
      this.setDrawer(false)
    }
  },

  data: () => ({
    errorCode: null,
    notAuthenticatedMenu: [
      {
        title: 'About Us',
        icon: 'mdi-information-outline',
        path: '/about'
      },
      {
        title: 'Login',
        icon: 'mdi-login',
        path: '/login'
      },
      // {
      //   title: 'Enroll',
      //   icon: 'mdi-account-plus-outline',
      //   path: '/enroll'
      // }
    ],
    authenticatedMenu: [
      {
        title: 'Claims',
        group: '/claim*/*',
        links: [
          {
            title: 'Submit a Claim',
            icon: 'mdi-lifebuoy',
            activeUserOnly: true,
            path: '/claim'
          },
          {
            title: 'View My Claims',
            icon: 'mdi-bank-transfer-in',
            path: '/claims/view',
          }
        ]
      },
      {
        title: 'Billing',
        group: '/invoice*/*',
        links: [
          {
            title: 'Make Payment',
            icon: 'mdi-cash-100',
            path: '/pay'
          },
          {
            title: 'View Invoices',
            icon: 'mdi-view-list-outline',
            path: '/invoices/view'
          },
          {
            title: 'View Suspensions',
            icon: 'mdi-account-cancel-outline',
            path: '/suspensions/view'
          },
          {
            title: 'Payment Information',
            icon: 'mdi-cash-100',
            path: '/payment-information'
          }
        ]
      },
      {
        title: 'Dependents',
        group: '/dependent*/*',
        links: [
          {
            title: 'Add Dependent',
            icon: 'mdi-account-child-outline',
            path: '/dependent',
          },
          {
            title: 'View Dependents',
            icon: 'mdi-family-tree',
            path: '/dependents/view',
          }
        ]
      },
      {
        title: 'My Account',
        group: '/account',
        links: [
          {
            title: 'View Account',
            icon: 'mdi-account-details-outline',
            path: '/account/view',
          },
          {
            title: 'Update Account',
            icon: 'mdi-account-edit-outline',
            path: '/account/update',
          },
          {
            title: 'Change Password',
            icon: 'mdi-lock-reset',
            path: '/account/password',
          },
          {
            title: 'Logout',
            icon: 'mdi-logout',
            path: '/logout',
          }
        ]
      },
      {
        title: 'About Tilyet',
        group: '/account',
        links: [
          {
            title: 'About Us',
            icon: 'mdi-information-outline',
            path: '/about'
          },
          {
            title: 'Links/Resources',
            icon: 'mdi-link-variant',
            path: '/resources'
          }
        ]
      }
  ]})
}
</script>

<style lang="sass">
@import '~vuetify/src/styles/tools/_rtl.sass'

.v-application a.unstyled-link
  &,
  &:link,
  &:visited,
  &:hover,
  &:active,
  &:focus
    color: inherit
    text-decoration: none
    background: none
    outline: none
  display: flex
  width: 100%
  height: 100%

.reset-image
  border-style: none
  vertical-align: middle

#core-navigation-drawer
  .v-list-group__header.v-list-item--active:before
    opacity: .24

  .v-list-item__avatar
    margin: 0px

  .display-2
    padding: 0 5px 0 5px

  .v-list-item__title, .v-list-group__items, .v-list-item__icon
    color: white
    padding: 0 5px 0 5px

  .v-list-group__items .v-list-item--active
    background: #4caf50

  .v-list-item
    &__icon--text,
    &__icon:first-child
      justify-content: center
      text-align: center
      width: 20px

      +ltr()
        margin-right: 24px
        margin-left: 12px !important

      +rtl()
        margin-left: 24px
        margin-right: 12px !important

  .v-list--dense
    .v-list-item
      &__icon--text,
      &__icon:first-child
        margin: 10px 5px 0 5px

  .v-list-group--sub-group
    .v-list-item
      +ltr()
        padding-left: 8px

      +rtl()
        padding-right: 8px

    .v-list-group__header
      +ltr()
        padding-right: 0

      +rtl()
        padding-right: 0

      .v-list-item__icon--text
        margin-top: 19px
        order: 0

      .v-list-group__header__prepend-icon
        order: 2

        +ltr()
          margin-right: 8px

        +rtl()
          margin-left: 8px

</style>
